import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';

/**
 * Contenedor del módulo Soporte. Igual que `audit` y `reports`: solo monta el
 * router-outlet y manda a `/support/menu` cuando entras a la ruta raíz.
 */
@Component({
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    RouterModule
  ],
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class SupportComponent implements OnInit {

  constructor(private router: Router) {}

  ngOnInit(): void {}

  ngDoCheck(): void {
    if (this.router.url === '/support') {
      this.router.navigate(['support/menu']);
    }
  }
}
